<template>
  <div id="news" class="div_card">     
    <span>類別選擇︰<el-radio-group v-model="userDpt" @change="getNewsData">
      <el-radio-button :label="item.groupID" :key="item.groupID" v-for="item in groupList">{{item.name}}</el-radio-button>
    </el-radio-group></span>  
    <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="'公告 [共'+ data1Len+'筆]'" name="first">
            <div class="dataTables_scroll">
                <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
                  <table style="margin:0.5em; width:100%;" cellspacing="0" >
                    <thead>
                        <tr>
                          <th style="width:10em; padding:0.5em;">發布日期</th>
                          <th style="padding:0.5em;">公告內容</th>
                        </tr>
                    </thead>
                  </table>
                </div>
                <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
                  <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                    <tbody>
                      <tr v-for="(item,index) in filterShoppingList1" :key="index" :index="'0'+index" :name="'N1'+index"
                          v-show="data1Len>0">
                        <td style="width:8em; padding:0.25em 0.5em; vertical-align: top;">
                          <i class="el-icon-time"></i>{{item.startDate | dateFormat}}<img src='@/assets/images/gif-new.gif' v-show="checkNewsTime(item.startDate)">
                        </td>
                        <td style="padding:0.25em 0.5em; vertical-align: top; display: inline-block;">
                          <span v-html="item.content" v-if="1==item.newsType"></span>
                          <span v-if="0==item.newsType">{{item.content}}</span>
                          <a v-for="(f,index) in item.info" :key="index" :index="'0'+index" :name="'F1'+index"
                            :href="'./WebApi/Tools/GetAttach/'+f.rowId" target="_blank"
                            :title="f.name">
                              <img v-if="f.img != null" :src="f.img" style="width:1.5em; height:1.5em;" alt="">
                              <span  v-if="f.img == null">
                                <img v-if="f.type === 'application/msword'" src="@/assets/images/word.gif" style="width:1.5em; height:1.5em;">
                                <img v-else-if="f.type === 'image/jpeg'" src="@/assets/images/image.gif" style="width:1.5em; height:1.5em;">
                                <img v-else-if="f.type === 'application/pdf'" src="@/assets/images/pdf.gif" style="width:1.5em; height:1.5em;">
                                <img v-else src="@/assets/images/attachment.png" style="width:1.5em; height:1.5em;">
                              </span>
                          </a>
                        </td>
                      </tr>
                      <tr v-show="0 == data1Len">
                        <td colspan="2" style="line-height:2.25em;">目前無公告~</td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </el-tab-pane>
        <el-tab-pane :label="'附表下載 [共'+ data2Len+'筆]'" name="second">
          <div class="dataTables_scroll">
            <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
              <table style="margin: 0.5em;width:100%;" cellspacing="0" >
                <thead>
                  <tr>
                    <th style="width:12em; padding:0.5em;">發布日期</th>
                    <th style="padding:0.5em;text-align:left;">檔案內容</th>
                    <th style="width:15em; padding:0.5em; text-align:left;">下載</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
              <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                  <tbody>
                  <tr v-for="(item,index) in filterShoppingList2" :key="index" :index="'0'+index" :name="'N2'+index"
                      v-show="data2Len>0">
                    <td style="width:10em; padding:0.25em 0.5em;">
                      <i class="el-icon-time"></i>{{item.startDate | dateFormat}}&nbsp;<img v-if="true" src="@/assets/images/gif-new.gif" v-show="checkNewsTime(item.startDate)"/>
                    </td>
                    <td style="padding:0.25em 0.5em;">
                      {{item.content}}
                    </td>
                    <td style="width:15em; padding:0.25em 0.5em;">
                      <a target="_blank" 
                        v-for="(f,index) in item.info" :key="index" :index="'0'+index" :name="'F2'+index"
                        :href="'./WebApi/Tools/GetAttach/'+f.rowId"
                        :title="f.name">
                        (<img src="@/assets/images/disk.png" /> {{f.ext}})
                      </a>
                    </td>
                  </tr>
                  <tr v-show="0 == data2Len">
                    <td colspan="3" style="line-height:2.25em;">目前無附表下載~</td>
                  </tr>
                  </tbody>    
              </table>    
            </div>    
          </div>
        </el-tab-pane>
        <el-tab-pane :label="'歷年簡章 [共'+ data3Len+'筆]'" name="three">
          <div class="dataTables_scroll">
            <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
              <table style="margin: 0.5em;width:100%;" cellspacing="0" >
                <thead>
                  <tr>
                    <th style="width:12em; padding:0.5em;">發布日期</th>
                    <th style="padding:0.5em;text-align:left;">檔案內容</th>
                    <th style="width:15em; padding:0.5em; text-align:left;">下載</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
              <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                  <tbody>
                  <tr v-for="(item,index) in filterShoppingList3" :key="index" :index="'0'+index" :name="'N3'+index"
                      v-show="data3Len>0">
                    <td style="width:10em; padding:0.25em 0.5em;">
                      <i class="el-icon-time"></i>{{item.startDate | dateFormat}}&nbsp;<img v-if="true" src="@/assets/images/gif-new.gif" v-show="checkNewsTime(item.startDate)"/>
                    </td>
                    <td style="padding:0.25em 0.5em;">
                      {{item.content}}
                    </td>
                    <td style="width:15em; padding:0.25em 0.5em;">
                      <a target="_blank" 
                        v-for="(f,index) in item.info" :key="index" :index="'0'+index" :name="'F2'+index"
                        :href="'./WebApi/Tools/GetAttach/'+f.rowId"
                        :title="f.name">
                        (<img src="@/assets/images/disk.png" /> {{f.ext}})
                      </a>
                    </td>
                  </tr>
                  <tr v-show="0 == data3Len">
                    <td colspan="3" style="line-height:2.25em;">目前無歷年簡章~</td>
                  </tr>
                  </tbody>    
              </table>    
            </div>    
          </div>
        </el-tab-pane>
    </el-tabs> 
  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      activeName: 'first',
      docRecordList: null,
      groupList: null,
      userDpt: 1,
      data1Len: 0,
      data2Len: 0,
      data3Len: 0
    }
  },
  methods: {
    checkNewsTime: function (startTime) {
      var date1 = new Date(startTime);
      var date2 = new Date();
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return (isNaN(diffDays) || (diffDays > 7) ? false : true);
    },
    getNewsData(item) {
      console.log("item", item);
      var vm = this
      var curDate = new Date()
      var url = './WebApi/Apply/GetSystemNews/'
          .concat(this.sysId)
          .concat('/').concat([curDate.getFullYear(),
             curDate.getMonth() + 1,
             curDate.getDate()].join('-'))
          .concat('/').concat(this.$store.state.user.status)
          .concat('/').concat(item)
      this.$http
        .get(url)
        .then(function(response) {
          vm.docRecordList = response.data;
          vm.data1Len = 0;
          vm.data2Len = 0;
          vm.data3Len = 0;
          if (null != vm.docRecordList) {
            for (var i=0; i < vm.docRecordList.length; i++) {
              switch(vm.docRecordList[i].newsType) {                
                case 2:
                  vm.data2Len +=1;
                  break;
                case 3:
                  vm.data3Len +=1;
                  break;
                default:
                  vm.data1Len +=1;
                  break;
              }
              // if (vm.docRecordList[i].newsType<2) {
              //   vm.data1Len +=1;
              // } else {
              //   vm.data2Len +=1;
              // }
            }
          }
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗');
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        }) 
      
    }
  },
  filters: {  
    dateFormat:function(input) {   
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate(); 
       return  year+ '/' + month + '/' + day ; 
    }  
  },
  computed: {
    filterShoppingList1: function () { 
      if (0 < this.data1Len) {
        var shoppingList = this.docRecordList;
          return shoppingList.filter(function (item) {
            return item.newsType<2
        });
      }
      return [];
    },
    filterShoppingList2: function () { 
      if (0 < this.data2Len) {
        var shoppingList = this.docRecordList;
          return shoppingList.filter(function (item) {
            return item.newsType==2
        });
      }
      return [];
    },
    filterShoppingList3: function () { 
      if (0 < this.data3Len) {
        var shoppingList = this.docRecordList;
          return shoppingList.filter(function (item) {
            return item.newsType==3
        });
      }
      return [];
    },    
    sysId () {
      return this.$store.getters.getSysId
    }
  },
  created () {
    console.log('======created GroupList =====')
    var vm = this
    var urlGroup = './WebApi/Apply/GetGroupSet/'
          .concat(this.sysId)
          .concat('/3')
    this.$http
        .get(urlGroup)
        .then(function(response) {
          vm.groupList = response.data;
          var gId = vm.groupList[0].groupID;
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗');
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        }) 
   
    //console.log('======created News =====')    
    this.getNewsData(1)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/NewsView.vue